import { Mediator, app, payload } from "modular-openscriptjs";
import { eParse, inform, processStart, processEnd } from "../helpers";
import { STRINGS, api } from "../declarations";
import { routes } from "../backendRoutes";

const $e = app("$e");

export class Surplus extends Mediator {
	$$surplus = {
		claimed: (ed, event) => {
			this.send($e.order.surplusClaimed, ed);
		},
		reimbursed: (ed, event) => {
			this.send($e.order.surplusPaid, ed);
			app("router").back();
		},

		needs: {
			claim: (ed, event) => this.claim(ed, event),
			negativeReimbursement: (ed, event) => this.getPayment(ed, event),
		},
	};

	$$payment = {
		completed: (ed, event) => {
			let data = eParse(ed);

			if ("order-payment-surplus" != data.meta.get("type")) return;

			inform("Reimbursement Completed", STRINGS.SUCCESS);

			this.broadcast($e.surplus.reimbursed, ed);
		},
	};

	async claim(ed, event) {
		let { message } = eParse(ed);

		if (!message.has("surplusId") || message.get("surplusId", 0) == 0) {
			inform("Invalid Surplus claim", STRINGS.WARNING);
			return this.send($e.surplus.has.claimError, ed);
		}

		processStart({ title: "Claiming surplus" });

		let res = await api.post(
			`${routes.orderPaymentSurpluses}/${message.get("surplusId")}/claim`
		);

		processEnd();

		if (!res) {
			return this.send($e.surplus.has.claimError, ed);
		}

		inform(res.message, STRINGS.SUCCESS);
		return this.send($e.surplus.claimed, ed);
	}

	async getPayment(ed, event) {
		let data = eParse(ed);

		if (data.message.get("surplus") == null) {
			inform("Invalid Overpayment", STRINGS.ERROR);

			return;
		}

		let surplus = data.message.get("surplus");

		data.meta.put(
			"route",
			`${routes.orderPaymentSurpluses}/${surplus?.id}/pay`
		);

		data.meta.put("type", "order-payment-surplus");
		data.meta.put("typeId", surplus?.id);
		data.message.put("amount", surplus?.amount);

		this.broadcast(
			$e.payment.needs.collection,
			payload(data.message, data.meta)
		);
	}
}
